export default "__VITE_ASSET__7$F02Odp__"